// Access to the data or mutation authorized
export const AUTHORIZATION_AUTHORIZED = "AUTHORIZED";
// Access to the data or mutation unauthorized
export const AUTHORIZATION_UNAUTHORIZED = "UNAUTHORIZED";
// Access to the data or mutation needs sign in to define if it is authorized or not
export const AUTHORIZATION_SIGNIN = "SIGNIN";
// Access to the data or mutation needs a filled viewer, and can be a user or anonymous
// user
export const AUTHORIZATION_WITH_VIEWER = "WITH_VIEWER";
// Access to the data or mutation is not available and the reason will be defined in the
// message presented to the viewer
export const AUTHORIZATION_UNAVAILABLE = "UNAVAILABLE";

export const isAuthorizedWithAuthentication = authorizationString =>
  authorizationString !== AUTHORIZATION_UNAUTHORIZED;

export const isUnauthorized = authorizationString =>
  authorizationString === AUTHORIZATION_UNAUTHORIZED;

export const isAuthorized = authorizationString =>
  authorizationString === AUTHORIZATION_AUTHORIZED;

export const isUnavailable = authorizationString =>
  authorizationString === AUTHORIZATION_UNAVAILABLE;

export const isUnauthorizedOrUnavailable = authorizationString =>
  isUnauthorized(authorizationString) || isUnavailable(authorizationString);
